import { AllieIconProps } from '../../../components';

export const BarChartIcon: React.FC<AllieIconProps> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M13.5 15V7.5M9 15V3M4.5 15V10.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
